import PageState from "./state";
import mutations from "./mutations";
import { getModule } from "@/store/store";
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"
let APIS = {
	//ajax地址
	getPayStatusInfo: `get /apis/moyin-account/v1/vip/getPayStatusInfo`,
	realVoiceSpeaker: `get /apis/tts-web-api/v1/realVoiceSpeaker/checkPayment?device=${device}`, //老版本真人配音使用
	realPersonVoiceoverSpeaker: `get /apis/moyin-real-voice-new/pay/checkPayment?device=${device}`, //新版本真人配音使用(查询状态使用)
	storeSpeaker: `get /apis/tts-web-api/v1/storeSpeaker/checkPaymentForH5`,
};
export default {
	...getModule({
		state: new PageState(),
		mutations,
		actions: {},
		APIS,
		name: "payMiddlePagePage",
	}),
};
